import React, { useState } from 'react';
import { Typography } from 'antd';
import '../styles.css';

const { Paragraph } = Typography;

const RecipeHeader = ({ name, description, image }) => {
  const [imageLoaded, setImageLoaded] = useState(false);

  return (
    <div>
      {image && (
        <div className={`recipe-header-container ${!imageLoaded ? 'loading' : ''}`}>
          <img
            src={image.imageUrl}
            alt={name}
            className="recipe-header-image"
            onLoad={() => setImageLoaded(true)}
            style={{ opacity: imageLoaded ? 1 : 0 }}
          />
          <h1 className="recipe-header-title-overlay">
            {name}
          </h1>
        </div>
      )}

      {!image && (
        <h1 className="recipe-header-title-no-image">
          {name}
        </h1>
      )}

      {description && (
        <Paragraph style={{ fontSize: '16px', color: '#666', marginBottom: '24px', marginTop: '16px' }}>
          {description}
        </Paragraph>
      )}
    </div>
  );
};

export default RecipeHeader;
